import { Flo } from '../../types/flo-auth-api'

export class WorkstationSubscriptionService implements ISubscriptionService {
  initialize() {
    console.log('WORKSTATION TODO')
  }

  getType(): string {
    return 'workstation'
  }

  async getProducts(): Promise<ProductList> {
    return [
      {
        id: 'stag_samsung_0000000000000004', // matches samsung product in staging for testing
        title: 'FloSports Yearly',
        description:
          'What you receive:|Billed Yearly|Stream unlimted events, live or on-demand|Access the full library of FloSports Originals|Get HD-quality streams and video|Watch on the web or the FloSports app - available on iOS, Android, Roku, Amazon Fire TV, Samsung, LG, Vizio, Google TV, and Apple TV',
        currency: 'CAD',
        price: 149.99,
      },
      {
        id: 'stag_samsung_0000000000000003', // matches samsung product in staging for testing
        title: 'FloSports Monthly',
        description:
          'What you receive:|Billed Monthly|Stream unlimted events, live or on-demand|Access the full library of FloSports Originals|Get HD-quality streams and video|Watch on the web or the FloSports app - available on iOS, Android, Roku, Amazon Fire TV, Samsung, LG, Vizio, Google TV, and Apple TV',
        currency: 'CAD',
        price: 29.99,
      },
      {
        id: 'stag_samsung_0000000000000002', // matches samsung product in staging for testing
        title: 'FloSports Yearly',
        description:
          'What you receive:|Billed Yearly|Stream unlimted events, live or on-demand|Access the full library of FloSports Originals|Get HD-quality streams and video|Watch on the web or the FloSports app - available on iOS, Android, Roku, Amazon Fire TV, Samsung, LG, Vizio, Google TV, and Apple TV',
        currency: 'CAD',
        price: 149.99,
      },
      {
        id: 'stag_samsung_0000000000000001', // matches samsung product in staging for testing
        title: 'FloSports Monthly',
        description:
          'What you receive:|Billed Monthly|Stream unlimted events, live or on-demand|Access the full library of FloSports Originals|Get HD-quality streams and video|Watch on the web or the FloSports app - available on iOS, Android, Roku, Amazon Fire TV, Samsung, LG, Vizio, Google TV, and Apple TV',
        currency: 'CAD',
        price: 29.99,
      },
    ]
  }

  buyProduct(): Promise<Purchase> {
    console.log('WORKSTATION TODO')
    return Promise.resolve(null)
  }

  createSubscription(
    offer: Flo.Offers.OffersResponseData,
    subscriptionId: string,
  ): Promise<Flo.Payments.SubscriptionResponse> {
    return Promise.resolve(null)
  }
}
